import React from "react";
import { Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import { useSelector, useDispatch } from "react-redux";
import { selectUserData, setNotifications } from "../features/auth/authSlice";
import { Link } from "react-router-dom";
import { useClearNotificationMutation } from "../features/auth/apiSlice";

const ShowNoticationsModal = ({
  setShowNotificationModal,
}: {
  setShowNotificationModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const notifications = useSelector(selectUserData).notifications;
  const sponserId = useSelector(selectUserData).sponserId;
  const [clearNotificationAPI] = useClearNotificationMutation();
  const dispatch = useDispatch();

  const handleNotificationClicked = async (notificationId: string) => {
    setShowNotificationModal(false);
    const response: any = await clearNotificationAPI({
      notificationId: notificationId,
      sponserId: sponserId,
    }).unwrap();
    dispatch(setNotifications({ notifications: response?.notifications }));
  };

  return (
    <div
      className="absolute top-8 p-5 z-10 left-[-80px]"
      style={{ backgroundColor: colors.grey[900] }}
    >
      {notifications?.length > 0 ? (
        notifications?.map((notification: any) => {
          return (
            <div
              key={notification._id}
              className="w-[200px] text-start border-[2px] border-green-600 p-1 hover:cursor-pointer select-none"
            >
              <Link
                to={"/feeds"}
                state={notification}
                onClick={() => handleNotificationClicked(notification._id)}
              >
                <Typography variant="h5">{notification.message}</Typography>
              </Link>
            </div>
          );
        })
      ) : (
        <div className="w-[200px] text-start border-[2px] border-green-600 p-1 hover:cursor-pointer select-none">
          <Typography variant="h5">No Current Notifications</Typography>
        </div>
      )}
    </div>
  );
};

export default ShowNoticationsModal;
